<template>
  <a-tabs defaultActiveKey="1" type="card" @tabClick="onTabClick">
    <a-tab-pane tab="当前版本" key="1">
      <j-form-container :disabled="formDisabled">
        <a-timeline mode="alternate">
          <a-timeline-item>
            项目基本信息创建<br/> {{model.createTime}} {{model.createByName}}<br/>
            项目名称： {{model.projectName}}<br/>
            客户名称： {{model.customerName}}
          </a-timeline-item>
          <!-- <a-timeline-item v-if="status > projectStatus.PLAN_FAIL">
            计划申请提交<br/> {{model.planApplyTime}} {{model.planCommitterName}}<br/>
            <j-upload v-model="model.planFile" disabled :buttonVisible="disabled"></j-upload>
          </a-timeline-item>
          <a-timeline-item color="green" v-if="status > projectStatus.CANCEL">
            计划申请审核通过<br/> {{model.planAuditTime}} {{model.planAuditorName}}
          </a-timeline-item> -->
          <a-timeline-item v-if="status > projectStatus.INITATION_WAIT && model.type == '0'">
            项目立项提交<br/> {{model.initiationCommitTime}} {{model.initiationCommitterName}} <br/>
            <j-upload v-model="model.attorneyUrl" disabled></j-upload>
            <j-upload v-model="model.agreementUrl" disabled></j-upload>
            <j-upload v-model="model.bidWinningNoticeUrl" disabled></j-upload>
            <j-upload v-model="model.policyUrl" disabled></j-upload>
          </a-timeline-item>
          <a-timeline-item color="green" v-if="status > projectStatus.INITATION_AUDIT && model.type == '0'">
            项目立项审核通过<br/> {{model.initiationAuditTime}} {{model.initiationAuditorName}}
          </a-timeline-item>
          <!-- <a-timeline-item color="red" v-if="status == projectStatus.CANCEL">
            项目撤销<br/> {{model.initiationAuditTime}}  {{model.initiationAuditorName}}
          </a-timeline-item> -->
          <a-timeline-item v-if="status > projectStatus.IDEA_WAIT">
            风险管理与保险解决方案提交<br/> {{model.riskManageCommitTime}}  {{model.riskManageCommitterName}}<br/>
            <j-upload v-model="model.riskManageFile" disabled></j-upload>
          </a-timeline-item>
          <a-timeline-item color="green" v-if="status > projectStatus.IDEA_AUDIT">
            风险管理与保险解决方案审核通过<br/> {{model.riskManageAuditTime}}  {{model.riskManageAuditorName}}
          </a-timeline-item>
          <a-timeline-item v-if="status > projectStatus.PURCHASE_WAIT">
            保险采购提交<br/> {{model.purchaseResultCommitTime}}  {{model.purchaseCommitterName}}<br/>
            <j-upload v-model="model.purchaseResultFile" disabled></j-upload>
          </a-timeline-item>
          <a-timeline-item color="green" v-if="status > projectStatus.PURCHASE_AUDIT">
            保险采购审核通过<br/> {{model.purchaseResultAuditTime}}  {{model.purchaseAuditorName}}
          </a-timeline-item>
          <a-timeline-item v-if="status > projectStatus.SIGN_WAIT">
            保险合同提交<br/> {{model.agreementCommitTime}}  {{model.agreementCommitterName}}<br/>
            <j-upload v-model="model.agreementFile" disabled></j-upload>
          </a-timeline-item>
          <a-timeline-item color="green" v-if="status > projectStatus.SIGN_AUDIT">
            保险合同审核通过<br/> {{model.agreementAuditTime}}  {{model.agreementAuditorName}}<br/>
          </a-timeline-item>
        </a-timeline>
      </j-form-container>
    </a-tab-pane>
    <a-tab-pane v-for="version in tabs" :tab="version" :key="version">
      <j-form-container :disabled="formDisabled">
        <a-timeline mode="alternate">
          <a-timeline-item>
            项目基本信息创建<br/> {{tabModel.createTime}} {{tabModel.createByName}}<br/>
            项目名称： {{tabModel.projectName}}<br/>
            客户名称： {{tabModel.customerName}}
          </a-timeline-item>
          <!-- <a-timeline-item v-if="status > projectStatus.PLAN_FAIL">
            计划申请提交<br/> {{model.planApplyTime}} {{model.planCommitterName}}<br/>
            <j-upload v-model="model.planFile" disabled :buttonVisible="disabled"></j-upload>
          </a-timeline-item>
          <a-timeline-item color="green" v-if="status > projectStatus.CANCEL">
            计划申请审核通过<br/> {{model.planAuditTime}} {{model.planAuditorName}}
          </a-timeline-item> -->
          <a-timeline-item v-if="model.type == '0'">
            项目立项提交<br/> {{tabModel.initiationCommitTime}} {{model.initiationCommitterName}} <br/>
            <j-upload v-model="tabModel.attorneyUrl" disabled></j-upload>
            <j-upload v-model="tabModel.agreementUrl" disabled></j-upload>
            <j-upload v-model="tabModel.bidWinningNoticeUrl" disabled></j-upload>
            <j-upload v-model="tabModel.policyUrl" disabled></j-upload>
          </a-timeline-item>
          <a-timeline-item color="green" v-if="model.type == '0'">
            项目立项审核通过<br/> {{tabModel.initiationAuditTime}} {{tabModel.initiationAuditorName}}
          </a-timeline-item>
          <!-- <a-timeline-item color="red" v-if="status == projectStatus.CANCEL">
            项目撤销<br/> {{model.initiationAuditTime}}  {{model.initiationAuditorName}}
          </a-timeline-item> -->
          <a-timeline-item>
            风险管理与保险解决方案提交<br/> {{tabModel.riskManageCommitTime}}  {{tabModel.riskManageCommitterName}}<br/>
            <j-upload v-model="tabModel.riskManageFile" disabled></j-upload>
          </a-timeline-item>
          <a-timeline-item color="green">
            风险管理与保险解决方案审核通过<br/> {{tabModel.riskManageAuditTime}}  {{tabModel.riskManageAuditorName}}
          </a-timeline-item>
          <a-timeline-item>
            保险采购提交<br/> {{tabModel.purchaseResultCommitTime}}  {{tabModel.purchaseCommitterName}}<br/>
            <j-upload v-model="tabModel.purchaseResultFile" disabled></j-upload>
          </a-timeline-item>
          <a-timeline-item color="green">
            保险采购审核通过<br/> {{tabModel.purchaseResultAuditTime}}  {{tabModel.purchaseAuditorName}}
          </a-timeline-item>
          <a-timeline-item>
            保险合同提交<br/> {{tabModel.agreementCommitTime}}  {{tabModel.agreementCommitterName}}<br/>
            <j-upload v-model="tabModel.agreementFile" disabled></j-upload>
          </a-timeline-item>
          <a-timeline-item color="green">
            保险合同审核通过<br/> {{tabModel.agreementAuditTime}}  {{tabModel.agreementAuditorName}}<br/>
          </a-timeline-item>
        </a-timeline>
      </j-form-container>
    </a-tab-pane>
  </a-tabs>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JUpload from '@/components/jeecg/JUpload'
  import ProjectStatus from '../../ProjectStatus'
  import { postAction } from '../../../../api/manage'

  export default {
    name: 'ArchivesManagementForm',
    components: {
      JUpload,
      JFormContainer,
    },
    props: {

    },
    data () {
      return {
        tabs: [],
        tabModel: {},
        description: '项目档案详情页面',
        model: {
        },
        projectStatus:{},
        status: null, // 记录状态数值
        disabled: true, // 禁用上传功能
        userMap: null, // 用户字典

        url: {
          queryById: "/project/apply/queryById",
          getSysUserList: "/sys/user/simplelist",
          hisData:"/project/archives/hisData",
        }
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
    },
    created () {
      this.projectStatus = ProjectStatus
    },
    methods: {
      onTabClick(key) {
        if(key == 1) {return;}
        let url = this.url.hisData;
        let tempModel = this.tabModel;
        let param = {version: key,id: this.tabModel.id,status: this.model.status};
        postAction(url,param).then((res)=>{
          if(res.success){
            if(res.result){
              // tempModel['projNum'] = '测试Click'+key;
              Object.keys(res.result).forEach(key => {
                tempModel[key] = res.result[key]
              })
            } else {
              callback('未找到该项目');
            }
          }else{
            callback(res.message);
          }
        })
      },
      async edit (record) {
        // 必须在前面调用，否则页面无法显示出同步查询到的用户姓名
        await this.getUserRealName(record);
        this.model = Object.assign({}, record);
        this.status = this.model.status
        // this.status = parseInt(this.model.status);
        let vs = this.model.versions
        if(vs) {
          this.tabModel = Object.assign({}, record);
          this.tabs = vs.split(',');
        } else {
          this.tabs = []
        }
      },
      async getUserRealName(record){
        this.userMap = new Map()

        let that = this
        // 获取系统用户字典
        await getAction(this.url.getSysUserList,{}).then((res) =>{
          if(res.success){
            for (let i = 0; i < res.result.length; i++) {
              let temp = res.result[i]
              that.userMap.set(temp.username, temp.realname)
            }
            //根据获取到的字典，设置实际姓名
            that.setUserRealNameByDict(record, that.userMap)
          }
        })
      },

      setUserRealNameByDict(model, userMap){
        // if(model.planCommitter){
        //   model.planCommitterName = userMap.get(model.planCommitter)
        // }
        // if(model.planAuditor){
        //   model.planAuditorName = userMap.get(model.planAuditor)
        // }
        if(model.initiationCommitter){
          model.initiationCommitterName = userMap.get(model.initiationCommitter)
        }
        if(model.initiationAuditor){
          model.initiationAuditorName = userMap.get(model.initiationAuditor)
        }

        if(model.riskManageCommitter){
          model.riskManageCommitterName = userMap.get(model.riskManageCommitter)
        }
        if(model.riskManageAuditor){
          model.riskManageAuditorName = userMap.get(model.riskManageAuditor)
        }

        if(model.purchaseCommitter){
          model.purchaseCommitterName = userMap.get(model.purchaseCommitter)
        }
        if(model.purchaseAuditor){
          model.purchaseAuditorName = userMap.get(model.purchaseAuditor)
        }

        if(model.agreementCreateBy){
          model.agreementCreateByName = userMap.get(model.agreementCreateBy)
        }
        if(model.agreementCommitter){
          model.agreementCommitterName = userMap.get(model.agreementCommitter)
        }
        if(model.agreementAuditor){
          model.agreementAuditorName = userMap.get(model.agreementAuditor)
        }
      },
    }
  }
</script>

<style>

</style>